import {
  CabinetConfigurationSettingsModel,
  CabinetConfigurationState,
  ConfigurationChangeModel,
  RootState,
  CabinetConfigurationSettingModel,
  ListConfigurationModel,
  StoreConstants
} from '@/types';
import { GetterTree } from 'vuex';

function findSetting(
  settings: CabinetConfigurationSettingModel[],
  settingName: string
): CabinetConfigurationSettingModel {
  return (
    settings?.find((x) => x.settingName.toLowerCase() === settingName.toLowerCase()) ??
    ({} as CabinetConfigurationSettingModel)
  );
}

export const getters: GetterTree<CabinetConfigurationState, RootState> = {
  [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChange](state): ConfigurationChangeModel {
    return state.cabinetConfigurationChange;
  },
  [StoreConstants.CabinetConfiguration.Getters.BypassConfigurationChangeLock](state): boolean {
    return state.cabinetConfigurationChange?.bypassLockingOnToolkit ?? false;
  },
  [StoreConstants.CabinetConfiguration.Getters.IsConfigurationLoading](state): boolean {
    return state.isLoading;
  },
  [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationLockHeldByCurrentSession](state): boolean {
    return (
      state.cabinetConfigurationChange?.lock != null && state.cabinetConfigurationChange.lock.isLockedByCurrentSessionId
    );
  },
  [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationSettings](state): CabinetConfigurationSettingsModel {
    return state.cabinetConfigurationSettings;
  },
  [StoreConstants.CabinetConfiguration.Getters.DocumentDateSetting]: (state) => (
    settingName: string
  ): CabinetConfigurationSettingModel => {
    return findSetting(state.cabinetConfigurationSettings?.documentDateStoringConfigurationOptions, settingName);
  },
  [StoreConstants.CabinetConfiguration.Getters.DocumentTypeStoringConfigurationSetting]: (state) => (
    settingName: string
  ): CabinetConfigurationSettingModel => {
    return findSetting(state.cabinetConfigurationSettings?.documentTypeStoringConfigurationOptions, settingName);
  },
  [StoreConstants.CabinetConfiguration.Getters.ReferenceStoringConfigurationSetting]: (state) => (
    settingName: string
  ): CabinetConfigurationSettingModel => {
    return findSetting(state.cabinetConfigurationSettings?.referenceStoringConfigurationOptions, settingName);
  },
  [StoreConstants.CabinetConfiguration.Getters.ReferenceSearchingConfigurationSetting]: (state) => (
    settingName: string
  ): CabinetConfigurationSettingModel => {
    return findSetting(state.cabinetConfigurationSettings?.referenceSearchingConfigurationOptions, settingName);
  },
  [StoreConstants.CabinetConfiguration.Getters.ListConfigurations]: (state): ListConfigurationModel[] => {
    return state.cabinetConfigurationSettings?.listConfigurations ?? ([] as ListConfigurationModel[]);
  },
  [StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationChangeId](state): number | null {
    return state.cabinetConfigurationChange?.id;
  },
  [StoreConstants.CabinetConfiguration.Getters.IsLockedByCurrentSessionId](state): boolean {
    return Boolean(state.cabinetConfigurationChange?.lock?.isLockedByCurrentSessionId);
  }
};
